// extracted by mini-css-extract-plugin
export var hideEditor = "_rz-2";
export var infoIcon = "_rz-3";
export var label = "_rz-1";
export var labelContainer = "_rz-0";
export var readonlyText = "_rz-4";